import { Link, useRouterState } from '@tanstack/react-router'
import { clsx } from 'clsx'
import { Home, Shield, User } from 'lucide-react'
import { useTranslation } from '@/shared/i18n/useTranslation'
import styles from './BottomTabBar.module.css'

/**
 * Mobile navigation, matching the sidebar.
 *
 * "Início" used to be missing entirely, so `/home` lit up the Ligas tab and a
 * survivor-only player had no way to tell where they were.
 *
 * "Ligas" is deliberately absent now: classic fantasy is frozen, so it is off
 * the menus. The routes still resolve for anyone holding a link.
 */
export function BottomTabBar() {
  const { t } = useTranslation()
  const { location } = useRouterState()
  const path = location.pathname

  const tabs = [
    { to: '/home',         label: t('nav.home'),     Icon: Home,   isActive: path === '/home' },
    { to: '/sobrevivente', label: t('nav.survivor'), Icon: Shield, isActive: path.startsWith('/sobrevivente') },
    { to: '/profile',      label: t('nav.profile'),  Icon: User,   isActive: path === '/profile' || path === '/preferences' || path === '/subscription' },
  ] as const

  return (
    <nav className={styles.bar} aria-label={t('nav.home')}>
      {tabs.map(({ to, label, Icon, isActive }) => (
        <Link
          key={to}
          to={to}
          search={{}}
          className={clsx(styles.tab, isActive && styles.isActive)}
          aria-current={isActive ? 'page' : undefined}
        >
          <span className={styles.tabIcon}>
            <Icon size={20} aria-hidden="true" />
          </span>
          <span className={styles.tabLabel}>{label}</span>
        </Link>
      ))}
    </nav>
  )
}
